.wrapper {
  display: flex;
  align-items: center;
}

.separator {
  --dot-size: 2px;

  display: inline-block;
  width: var(--dot-size);
  min-width: var(--dot-size);
  height: var(--dot-size);
  min-height: var(--dot-size);
  margin-right: var(--rc-theme-spacing-xs);
  margin-left: var(--rc-theme-spacing-xs);
  border-radius: 50%;
  background: var(--rc-theme-color-text-secondary);
}
